import { render, staticRenderFns } from "./AccessCreate.vue?vue&type=template&id=b9d33cf4"
import script from "./AccessCreate.vue?vue&type=script&lang=js"
export * from "./AccessCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports